// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_ribbon__GumFy {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.style_ribbon__left__p32Z8 {
  transform: rotate(-180deg);
  position: absolute;
  width: 48px;
  left: -185px;
  top: 25px;
  height: 60px;
  background: linear-gradient(270deg, #7553f0 41.46%, #552ee0 100%);
  border-radius: 4px;
  clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 50% 50%, 100% 100%, 100% 100%, 0% 100%);
}

.style_ribbon__content__APFNK {
  width: 300px;
  height: 60px;
  position: absolute;
  z-index: 9;
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgb(117, 83, 240);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: 0px 2px 0px 2px rgb(117, 83, 240);
  padding: 4px 0;
}
.style_ribbon__content__title__OmoZ3 {
  font-size: 24px;
  font-weight: 800;
  color: rgb(255, 255, 255);
  margin-bottom: 8px;
}
.style_ribbon__content__subtitle__Le21a {
  font-size: 16px;
  color: rgb(255, 255, 255);
}

.style_ribbon__right__BYAJM {
  position: absolute;
  width: 48px;
  height: 60px;
  top: 25px;
  right: -185px;
  z-index: 7;
  background: linear-gradient(270deg, #7553f0 41.46%, #552ee0 100%);
  border-radius: 4px;
  clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 50% 50%, 100% 100%, 100% 100%, 0% 100%);
}`, "",{"version":3,"sources":["webpack://./src/components/achievement-reward/ribbon/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,0BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,iEAAA;EACA,kBAAA;EACA,mFAAA;AADF;;AAYA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BCzCK;ED0CL,4BAAA;EACA,6BAAA;EACA,6CAAA;EACA,cAAA;AATF;AAUE;EACE,eAAA;EACA,gBAAA;EACA,yBC5CI;ED6CJ,kBAAA;AARJ;AAWE;EACE,eAAA;EACA,yBClDI;ADyCR;;AAaA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EAEA,iEAAA;EACA,kBAAA;EACA,mFAAA;AAXF","sourcesContent":["@import 'public/assets/colors';\n\n.ribbon {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.ribbon__left {\n  transform: rotate(-180deg);\n  position: absolute;\n  width: 48px;\n  left: -185px;\n  top: 25px;\n  height: 60px;\n  background: linear-gradient(270deg, #7553f0 41.46%, #552ee0 100%);\n  border-radius: 4px;\n  clip-path: polygon(\n    0% 0%,\n    100% 0%,\n    100% 0%,\n    50% 50%,\n    100% 100%,\n    100% 100%,\n    0% 100%\n  );\n}\n\n.ribbon__content {\n  width: 300px;\n  height: 60px;\n  position: absolute;\n  z-index: 9;\n  margin-top: 10px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: $main;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  box-shadow: 0px 2px 0px 2px $main;\n  padding: 4px 0;\n  &__title {\n    font-size: 24px;\n    font-weight: 800;\n    color: $white;\n    margin-bottom: 8px;\n  }\n\n  &__subtitle {\n    font-size: 16px;\n    color: $white;\n  }\n}\n\n.ribbon__right {\n  position: absolute;\n  width: 48px;\n  height: 60px;\n  top: 25px;\n  right: -185px;\n  z-index: 7;\n\n  background: linear-gradient(270deg, #7553f0 41.46%, #552ee0 100%);\n  border-radius: 4px;\n  clip-path: polygon(\n    0% 0%,\n    100% 0%,\n    100% 0%,\n    50% 50%,\n    100% 100%,\n    100% 100%,\n    0% 100%\n  );\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ribbon": `style_ribbon__GumFy`,
	"ribbon__left": `style_ribbon__left__p32Z8`,
	"ribbon__content": `style_ribbon__content__APFNK`,
	"ribbon__content__title": `style_ribbon__content__title__OmoZ3`,
	"ribbon__content__subtitle": `style_ribbon__content__subtitle__Le21a`,
	"ribbon__right": `style_ribbon__right__BYAJM`
};
export default ___CSS_LOADER_EXPORT___;
